import React from "react";
import LoadingGIF from "assets/loading.gif";
import { cn } from "lib/utils";

export default function LoadingSpinner({
  isLoading = "Loading...",
  isSuccess = null,
  className,
  subtitle,
}) {
  return (
    <div
      className={cn(
        "flex flex-col gap-8 justify-center items-center h-[calc(100vh-81px)]",
        className
      )}
    >
      {isSuccess ? (
        <svg
          width="90px"
          height="140px"
          viewBox="0 0 133 133"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          style={{ paddingTop: "10px" }}
        >
          <g
            id="check-group"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <circle
              id="filled-circle"
              fill="#008835"
              cx="66.5"
              cy="66.5"
              r="54.5"
            />
            <circle
              id="white-circle"
              fill="#FFFFFF"
              cx="66.5"
              cy="66.5"
              r="55.5"
            />
            <circle
              id="outline"
              stroke="#008835"
              strokeWidth="4"
              cx="66.5"
              cy="66.5"
              r="54.5"
            />
            <polyline
              id="check"
              stroke="#FFFFFF"
              strokeWidth="10"
              points="41 70 56 85 92 49"
            />
          </g>
          <style>
            {`
              #check-group {
                animation: 0.32s ease-in-out 1.03s check-group;
                transform-origin: center;
              }

              #check-group #check {
                animation: 0.34s cubic-bezier(0.65, 0, 1, 1) 0.8s forwards check;
                stroke-dasharray: 0, 75px;
              }

              #check-group #outline {
                animation: 0.38s ease-in outline;
                transform: rotate(0deg);
                transform-origin: center;
              }

              #check-group #white-circle {
                animation: 0.35s ease-in 0.35s forwards circle;
                transform: none;
                transform-origin: center;
              }

              @keyframes outline {
                from {
                  stroke-dasharray: 0, 345.576px;
                }
                to {
                  stroke-dasharray: 345.576px, 345.576px;
                }
              }
              @keyframes circle {
                from {
                  transform: scale(1);
                }
                to {
                  transform: scale(0);
                }
              }
              @keyframes check {
                from {
                  stroke-dasharray: 0, 75px;
                }
                to {
                  stroke-dasharray: 75px, 75px;
                }
              }
              @keyframes check-group {
                from {
                  transform: scale(1);
                }
                50% {
                  transform: scale(1.09);
                }
                to {
                  transform: scale(1);
                }
              }
            `}
          </style>
        </svg>
      ) : (
        <img src={LoadingGIF} alt="" className="w-[72px] h-[140px]" />
      )}
      <h1 className="font-semibold text-6xl text-center px-8">
        {isSuccess ? isSuccess : isLoading}
      </h1>
      {subtitle && (
        <p className="text-center text-tertiary text-lg max-w-[300px] -mt-4 mb-4">
          {subtitle}
        </p>
      )}
    </div>
  );
}
